import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import useUserContext from '../hooks/use-user-context';
import { createOptionMap } from '../utilities/misc';
import Banner from './Banner';

const GlobalBanner = () => {
  const data = useStaticQuery(graphql`
  query PromoBanner {
    allContentfulOptionSet(filter: {name: {eq: "promo_banner"}}) {
      nodes {
        ...OptionSetFragment
      }
    }
  }
`);
  const { language } = useUserContext();
  const options = createOptionMap(data.allContentfulOptionSet.nodes, language);

  if (options['promo_banner.show'] !== 'true') {
    return null;
  }

  return (
    <Banner
      text={options['promo_banner.link_text']}
      link={options['promo_banner.link']}
    />
  );
};

export default GlobalBanner;
